import * as React from 'react';
import { Spinner } from '@cian/ui-kit/internal/components/Spinner';

import * as styles from './Loader.css';

export function Loader() {
  return (
    <div className={styles['loader']}>
      <Spinner fillColor="currentColor" />
    </div>
  );
}
